module.exports = __webpack_public_path__ + "static/avatar-06d044d09a2e514c510fd10d0294a6fb.jpg";